import YourFinanceQuote from './YourFinanceQuote';

export default YourFinanceQuote;
